import { defineComponent as _defineComponent } from 'vue'
import { onMounted, toRefs, watch } from "vue";
import { LogService } from "@/services";
import { useRoute } from "vue-router/composables";
import { VignetteRoutes } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadMetadata',
  props: {
    title: { default: "" }
  },
  setup(__props: any) {

const props = __props as { title: string };

const route = useRoute();



const { title } = toRefs(props);
watch(title, () => {
  updateAttributes();
});

const handleBrowserTabTitle = (title: string) => {
  const routeName = route.name ?? "";
  switch (routeName) {
    case VignetteRoutes.Home:
      document.title = "Almanac+";
      break;
    case VignetteRoutes.SearchUniversal:
    case VignetteRoutes.SearchFederal:
    case VignetteRoutes.SearchState:
    case VignetteRoutes.SearchCongressional:
      document.title = "Almanac+ Search";
      break;
    case VignetteRoutes.Faq:
      document.title = "Almanac+ FAQ";
      break;
    case VignetteRoutes.Briefcase:
    case VignetteRoutes.BriefcaseFolder:
      document.title = "Almanac+ Briefcase";
      break;
    case VignetteRoutes.BrowseByState:
    case VignetteRoutes.BrowseByAgency:
    case VignetteRoutes.BrowseByGroup:
    case VignetteRoutes.ProfileKW:
    case VignetteRoutes.District:
    case VignetteRoutes.State:
    case VignetteRoutes.Committee:
    case VignetteRoutes.Caucus:
    case VignetteRoutes.Agency:
    case VignetteRoutes.Profile:
      document.title = title + " - Almanac+";
      break;
    case VignetteRoutes.Loading:
      document.title = "Loading";
      break;
    default:
      document.title = "Almanac+";
  }
};

const setHeadElementAttribute = (selector: string, attribute: string) => {
  const el: Element | null = document.querySelector(selector);

  if (!el) {
    LogService.error(`HeadMetadata : head element '${selector}' is missing`);
  } else {
    if (!attribute) {
      el.removeAttribute("content");
    } else {
      el.setAttribute("content", attribute);
    }
  }
};
onMounted(() => {
  updateAttributes();
});
const updateAttributes = () => {
  LogService.info("HeadMetadata : updateAttributes");
  if (title.value) {
    handleBrowserTabTitle(title.value);
    setHeadElementAttribute('meta[itemprop="name"]', document.title);
    setHeadElementAttribute('meta[property="og:title"]', document.title);
    setHeadElementAttribute('meta[name="twitter:title"]', document.title);
  }
};

return { __sfc: true,route, props, title, handleBrowserTabTitle, setHeadElementAttribute, updateAttributes }
}

})